import { useCallback } from "react";

export const useScrollToSection = () => {
  const scrollToSection = useCallback((sectionId: string) => {
    // Remove # if it's there
    const id = sectionId.startsWith("#") ? sectionId.substring(1) : sectionId;
    const element = document.getElementById(id);

    if (element) {
      // With Locomotive Scroll 5, standard scrollIntoView works well
      // because it uses native scroll.
      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, []);

  return scrollToSection;
};
